import type { Theme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'
import type { SxProps } from '@mui/material'
import type { ProductUpdateHighlightKind } from '../../../../types/ProductUpdates'

/** Chip colors for release highlight kinds — palette-based for light/dark. */
export function productUpdateHighlightSx(
  theme: Theme,
  kind: ProductUpdateHighlightKind
): SxProps<Theme> {
  switch (kind) {
    case 'feature':
      return { bgcolor: alpha(theme.palette.success.main, 0.14), color: 'success.main' }
    case 'fix':
      return { bgcolor: alpha(theme.palette.info.main, 0.14), color: 'info.main' }
    case 'improvement':
      return { bgcolor: alpha(theme.palette.warning.main, 0.14), color: 'warning.main' }
    default:
      return {
        bgcolor: alpha(theme.palette.primary.main, 0.12),
        color: 'primary.main',
      }
  }
}
